/* eslint-disable max-statements */
import { combineReducers } from 'redux';
import { ActionType, AppError } from './types';
const reducers = {
  viewerProgress: (state = {
    loading: false,
    invalidated: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_VIEWER_PROGRESS_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_VIEWER_PROGRESS_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_VIEWER_PROGRESS_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  creatorProgress: (state = {
    loading: false,
    invalidated: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CREATOR_PROGRESS_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_CREATOR_PROGRESS_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_CREATOR_PROGRESS_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  }
};
const appReducer = combineReducers(reducers);
export { reducers };
export default appReducer;